// extracted by mini-css-extract-plugin
export var sectionContainer = "styles-module--sectionContainer--35KGS";